import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { useLocation } from "react-router-dom";

/**
 * GTM(Google Tag manager)向けの設定を記述
 * SPA向けに、通常のページ読み込み時に処理される方式でなく
 * パスが変化したタイミングでgtag()メソッドを実行するよう設定済み
 */
function GtmHandler() {
  // パス変更検知用
  const location = useLocation();

  /**
   * 初回読み込み時のみ実行、gtag.jsをhtmlに読み込み
   */
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview", // GTMのトリガーで設定するイベント名を設定
        page: {
          url: location.pathname, // GTMのデータレイヤー変数で設定する画面URL
          title: document.title, // GTMのデータレイヤー変数で設定する画面タイトル
        }
      }
    });
  }, []);

  /**
   * パスが変わったタイミングで実行、gtag()メソッドを実行しGTM処理
   */
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview", // GTMのトリガーで設定するイベント名を設定
        page: {
          url: location.pathname, // GTMのデータレイヤー変数で設定する画面URL
          title: document.title, // GTMのデータレイヤー変数で設定する画面タイトル
        }
      }
    })
  }, [location]);

  return <></>;
}

export default GtmHandler;
